module.exports = __webpack_public_path__ + "img/methodist.72f1aeec.png";